import { MouseEventHandler } from "react";

import {
  ROLES_WIZARD_DELETE_GROUP,
  ROLES_WIZARD_SET_ASSIGN_PRIVILEGES,
  ROLES_WIZARD_SET_RESOURCE_OBJECTS,
  ROLES_WIZARD_SET_REVOKE_PRIVILEGES,
  ROLES_WIZARD_TOGGLE_EXPAND_GROUP,
} from "../privilegesReducer";
import { usePrivilegesState } from "../usePrivilegesContext";

export const usePrivilegesHandlers = ({
  resource,
  index,
  catalogName,
}: {
  resource: string;
  index: number;
  catalogName?: string;
}) => {
  const { privilegesDispatch } = usePrivilegesState();

  const onGrantPrivileges = (items: string[]) => {
    privilegesDispatch({
      type: ROLES_WIZARD_SET_ASSIGN_PRIVILEGES,
      resource,
      privileges: items,
      index,
      catalogName,
    });
  };

  const onRevokePrivileges = (items: string[]) => {
    privilegesDispatch({
      type: ROLES_WIZARD_SET_REVOKE_PRIVILEGES,
      resource,
      privileges: items,
      index,
      catalogName,
    });
  };

  const onSelectResourceObjects = (items: string[]) => {
    privilegesDispatch({
      type: ROLES_WIZARD_SET_RESOURCE_OBJECTS,
      resource,
      objects: items,
      index,
      catalogName,
    });
  };

  const handleMore: MouseEventHandler = event => {
    event.stopPropagation();
    privilegesDispatch({
      type: ROLES_WIZARD_TOGGLE_EXPAND_GROUP,
      index,
      resource,
      catalogName,
    });
  };

  const deleteGroup = () => {
    privilegesDispatch({
      type: ROLES_WIZARD_DELETE_GROUP,
      resource,
      index,
      catalogName,
    });
  };

  return {
    onGrantPrivileges,
    onRevokePrivileges,
    onSelectResourceObjects,
    deleteGroup,
    handleMore,
  };
};
